import ReactPixel from 'react-facebook-pixel';

const IS_LIVE_SITE = document.location.hostname.indexOf("www.kickavenue.com") !== -1

class FbPixel {
  constructor(){
    if (IS_LIVE_SITE) 
      ReactPixel.init('568891920587593');
  }

  recordEvent(eventName, data){
    if (IS_LIVE_SITE) 
      return ReactPixel.track( eventName, data ) 
  }

  recordCustomEvent(eventName, data){
    if (IS_LIVE_SITE) 
      return ReactPixel.trackCustom( eventName, data ) 
  }
}
const Pixel = new FbPixel()
export default Pixel